export type ScrollFadeEdge = "start" | "end" | "both";

/** Which edges of a horizontal scroller hide content (1 px tolerance). */
export function scrollFadeEdge(scrollLeft: number, clientWidth: number, scrollWidth: number): ScrollFadeEdge | undefined {
  const before = scrollLeft > 1;
  const after = scrollLeft + clientWidth < scrollWidth - 1;
  if (before && after) return "both";
  if (before) return "start";
  if (after) return "end";
  return undefined;
}
